/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const GreenCheck = ({size, ...props}) => (
  <svg viewBox="0 0 18 18" fill="currentColor" width={ size || "18" } height={ size || "18" } {...props}>
    <defs>
      <filter id="prefix__a" width="100%" height="100%" x="-150%" y="-150%" filterUnits="objectBoundingBox">
        <feOffset dy="6" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3" />
        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.06 0" />
        <feOffset in="SourceAlpha" result="shadowOffsetOuter2" />
        <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="9" />
        <feColorMatrix in="shadowBlurOuter2" result="shadowMatrixOuter2" values="0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0" />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="shadowMatrixOuter2" />
        </feMerge>
      </filter>
      <rect id="prefix__b" width="18" height="18" x="0" y="0" rx="9" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <use fill="#000" filter="url(#prefix__a)" xlinkHref="#prefix__b" />
      <use fill="#46D895" xlinkHref="#prefix__b" />
      <path d="M11.94 6c.292-.293.767-.293 1.06 0 .293.293.293.768 0 1.06l-5.5 5.5-2.5-2.5c-.293-.292-.293-.767 0-1.06.293-.293.768-.293 1.06 0l1.44 1.44L11.94 6z"
        fill="#FFF" />
    </g>
  </svg>
);
GreenCheck.displayName = 'GreenCheck';
GreenCheck.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
